const interfacePhrases = {
    rate_limited: 'レート制限',
    limit_exceeded: '上限超過',
    used: '使用',
    identifier: '識別子',
    verification: '検証',
    messages: 'メッセージ',
    data: 'データ',
    custom: 'カスタム',
    management_api: '{{product}} 管理 API',
    management_api_role_description: 'この組み込みロールは管理 API へのアクセスを許可します。',
    client_credentials: 'クライアント認証情報',
    authentication_request: '認証リクエスト',
    callback: '認証コールバック',
    help_title: 'iden ヘルプセンター',
    help_subtitle: '作業画面を離れずにヘルプを確認',
    open_help: 'ヘルプページ全体を開く',
    close_help: 'ヘルプを閉じる',
    about: '製品情報とオープンソース',
    open_navigation: 'ナビゲーションを開く',
    close_navigation: 'ナビゲーションを閉じる',
    development_enabled: '開発機能が有効です',
    beta: 'ベータ版',
    impersonation: '代理ログイン',
    key: 'キー',
    value: '値',
    error: 'エラー',
    details: '技術的な詳細',
    callback_failed: 'サインインのコールバックを完了できませんでした。',
    back_sign_in: 'サインインに戻る',
    powered_by: '提供元',
    avatar: 'アバター',
    logo: 'ロゴ',
    qr_code: 'QR コード',
    sample_title: 'サンプルを見てみませんか？',
    sample_description: 'このガイドを使ったサンプルアプリをご覧ください。',
    sample_action: 'サンプルを見る',
    further_readings: '関連情報',
    complete_guide: '完全ガイド',
    custom_domains_notice: '<a>カスタムドメイン</a>を追加すると、次のエンドポイントを使用できます：<code>{{endpoint}}</code>。',
    my_project: 'マイプロジェクト',
    my_secret: 'マイシークレット',
    my_token: 'マイトークン',
    role_example: '閲覧者',
    reset_retry: '設定をリセットして再試行',
    open_dev_panel: '開発者パネルを開く',
    close_dev_panel: '開発者パネルを閉じる',
    configuration: '設定',
    app_id: 'アプリケーション ID',
    extra_parameters: '追加のサインインパラメーター',
    prompt: '認証プロンプト',
    scope: 'スコープ',
    resource: 'リソース',
    resources_space_delimited: 'リソース（スペース区切り）',
    sign_out_to_apply: '変更を適用するにはサインアウトしてください。',
    refresh_token_grant: 'リフレッシュトークンによる認可',
    organization_id: '組織 ID',
    console_result: '結果はブラウザーのコンソールで確認できます。',
    request_token: 'トークンを要求',
    user_info: 'ユーザー情報',
    get_id_token_claims: 'ID トークンのクレームを取得',
    fetch_user_info: 'ユーザー情報を取得',
    device_initializing: 'デバイス認可を初期化しています…',
    device_success: 'デモアプリへのサインインが完了しました。',
    sign_in_information: 'サインイン情報：',
    email: 'メールアドレス',
    username: 'ユーザー名',
    user_id: 'ユーザー ID',
    sign_out_demo: 'デモからサインアウト',
    device_expired: 'デバイスコードの有効期限切れ',
    generic_error: 'エラーが発生しました',
    device_expired_description: 'デバイスコードの有効期限が切れました。再試行して新しいコードを取得してください。',
    sign_in_title: 'アカウントにサインイン',
    scan_instruction: 'QR コードをスキャンするか、別のデバイスで次のアドレスを開いてください：',
    one_time_code: 'ワンタイムコードを入力',
    token_info: 'トークン情報',
    get_access_token: 'アクセストークンを取得',
    context_unavailable: 'アカウント情報を読み込めません。',
    not_initialized: 'アカウント情報が初期化されていません。',
    not_set: '未設定',
    configured: '設定済み',
    password: 'パスワード',
    phone: '電話番号',
    search_help: 'ヘルプを検索',
    language: '言語',
    menu: 'メニュー',
    compatibility_notice: '互換性について：Logto から継承した SDK、パッケージ、プロトコル、コンポーネント、リクエストヘッダーの名前は変更されません。',
    source: '出典',
    upstream_repository: '上流リポジトリ',
    current_fork: '現在のリポジトリ',
    license_notice: 'iden は Mozilla Public License 2.0 に基づくオープンソースソフトウェア Logto を基盤としています。',
    about_description: '製品情報とオープンソースの帰属表示。',
    page_not_found: 'ページが見つかりません',
    page_not_found_description: 'このページは利用できません。ヘルプセンターに戻ってください。',
    introduction: 'はじめに',
    quick_starts: 'クイックスタート',
    integration: '統合',
    end_user_flows: 'エンドユーザーフロー',
    authorization: '認可',
    user_management: 'ユーザー管理',
    security: 'セキュリティ',
    customization: 'カスタマイズ',
    connectors: 'コネクター',
    organizations: '組織',
    self_hosting: 'セルフホスティング',
    continue: '続行',
    loading: '読み込み中…',
    save: '保存',
    saved: '保存済み',
    try_again: '再試行',
    client_id: 'クライアント ID',
    client_secret: 'クライアントシークレット',
    redirect_uri: 'リダイレクト URI',
    status: '状態',
    type: '種類',
    permissions: '権限',
    token_data: 'トークンデータ',
    context_data: 'コンテキストデータ',
    jwt_extra_claims: '追加のトークンクレーム',
    action_result: 'アクション結果',
    social_account_already_linked: 'このソーシャルアカウントはすでに連携されています。',
};
export default Object.freeze(interfacePhrases);
